export const MESSAGES_UPLOAD_DOCUMENT = 'MESSAGES_UPLOAD_DOCUMENT';
export const MESSAGES_SELECT_DOCUMENT = 'MESSAGES_SELECT_DOCUMENT';

export const ACTIVE_THREAD_CONTAINER = 'ACTIVE_THREAD_CONTAINER';
export const ACTIVE_THREAD_TITLE = 'ACTIVE_THREAD_TITLE';
export const ACTIVE_THREAD_MESSAGES = 'ACTIVE_THREAD_MESSAGES';
export const ACTIVE_THREAD_FILE = 'ACTIVE_THREAD_FILE';
export const ACTIVE_THREAD_INPUT = 'ACTIVE_THREAD_INPUT';
